import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { AuthGuardService } from "./auth-guard.service";
import { filter, first, map, Observable, switchMap, } from "rxjs";
import { PortalRole } from "../../model/auth.model";

/**
 * The guard function for child routes
 * @returns boolean if the user is logged in
 */
export const loginGuardChildren = (rolesAllowed: PortalRole[] = []): CanActivateChildFn => {
    return () => loginVerification(rolesAllowed);
}

/**
 * The guard function for single routes
 * @returns boolean if the user is logged in
 */
export const loginGuardSinglePage = (rolesAllowed: PortalRole[] = []): CanActivateFn => {
    return () => loginVerification(rolesAllowed);
}

/**
 * The function to verify the login status
 * @returns boolean if the user is logged in
 */
const loginVerification = (rolesAllowed: PortalRole[] = []): Observable<boolean> => {
    const authGuardService = inject(AuthGuardService);
    const router = inject(Router);
    return authGuardService.authStoreReady().pipe(
        filter(authStoreReady => authStoreReady),
        switchMap(() => authGuardService.getLoggedInGuard()),
        first(),
        map(({ role, loggedIn }) => {
            if (!loggedIn) {
                router.navigate(['/start']);
            }
            let isAllowed = true;
            if ((rolesAllowed.length > 0)) {
                isAllowed = role ? rolesAllowed.includes(role) : false;
            }
            return loggedIn && isAllowed;
        })
    );
}